// extracted by mini-css-extract-plugin
module.exports = {"toggleButton":"ToggleButton_toggleButton__C9rvx","buttonText":"ToggleButton_buttonText__AjYmm"};